module.exports = __webpack_public_path__ + "static/media/linked.2bd799a3.svg";